import { render } from "./GoodsReceiptTableIndex.vue?vue&type=template&id=e028fefe"
import script from "./GoodsReceiptTableIndex.vue?vue&type=script&lang=js"
export * from "./GoodsReceiptTableIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__